export default __webpack_public_path__ + "static/media/logoWhite.b510b318.png";